import type { DeviceIncidentStatusReadModel } from "@billiard/contracts";

export const DEVICE_INCIDENT_MAX_AGE_MS = 5_000;

export interface DeviceIncidentTrustInput {
  data: DeviceIncidentStatusReadModel | undefined;
  dataUpdatedAt: number;
  isPending: boolean;
  isError: boolean;
  isRefetchError?: boolean;
  failureCount: number;
}

export type DeviceIncidentTrustState =
  | { kind: "LOADING" }
  | { kind: "ERROR" }
  | { kind: "STALE" }
  | { kind: "EMPTY" }
  | { kind: "READY"; incidents: DeviceIncidentStatusReadModel["attention"] };

export function deviceIncidentTrustState(
  input: DeviceIncidentTrustInput,
  nowMs = Date.now(),
  maxAgeMs = DEVICE_INCIDENT_MAX_AGE_MS,
): DeviceIncidentTrustState {
  if (!input.data) {
    return input.isPending && !input.isError ? { kind: "LOADING" } : { kind: "ERROR" };
  }
  if (input.isError || input.isRefetchError || input.failureCount > 0) {
    return { kind: "ERROR" };
  }
  const ageMs = nowMs - input.dataUpdatedAt;
  if (!Number.isFinite(ageMs) || ageMs < 0 || ageMs > maxAgeMs) {
    return { kind: "STALE" };
  }
  return input.data.attention.length === 0
    ? { kind: "EMPTY" }
    : { kind: "READY", incidents: input.data.attention };
}

export function startDeviceIncidentTrustClock(
  update: (nowMs: number) => void,
  now: () => number = () => Date.now(),
  schedule: (
    tick: () => void,
    intervalMs: number,
  ) => ReturnType<typeof globalThis.setInterval> = globalThis.setInterval,
  cancel: (timer: ReturnType<typeof globalThis.setInterval>) => void = globalThis.clearInterval,
): () => void {
  update(now());
  const timer = schedule(() => update(now()), 1_000);
  return () => cancel(timer);
}
